import { useQuery } from '@tanstack/react-query'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'

export const useGetWishlist = (id: string, isLoggedIn: boolean) => {
    return useQuery({
        queryKey: QueryKeys.PDP.Wishlist(id),
        queryFn: async () =>
            fetchRequest({
                serviceName: 'ntl',
                method: 'GET',
                endpoint: `/wishlist/product-id/${id}`,
            }),
        enabled: !!id && isLoggedIn,
    })
}
